import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const ease = [0.76, 0, 0.24, 1];

const EMAIL = "hello@asrafnoor.com";

export const Contact = () => {
  return (
    <footer id="contact" data-testid="contact-section" className="relative pt-24 md:pt-40 pb-10">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-outfit text-xs uppercase tracking-[0.3em] text-[#e1ff00] mb-8"
        >
          Available for freelance & collaboration
        </motion.p>

        {/* Massive CTA */}
        <a
          href={`mailto:${EMAIL}?subject=Let%27s%20make%20something%20cinematic`}
          data-testid="email-cta"
          data-cursor-hover
          className="group block"
        >
          <motion.h2
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease }}
            className="font-bebas uppercase leading-[0.82] tracking-tight text-white group-hover:text-[#e1ff00] transition-colors duration-500 text-[18vw] md:text-[15vw]"
          >
            Let's talk
            <ArrowUpRight className="inline-block h-[10vw] w-[10vw] align-top text-[#e1ff00] transition-transform duration-500 group-hover:translate-x-4 group-hover:-translate-y-2" />
          </motion.h2>
        </a>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 mt-12 border-t border-white/10 pt-10">
          <div>
            <p className="font-outfit text-xs uppercase tracking-[0.2em] text-neutral-500 mb-2">
              Drop a line
            </p>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="email-link"
              className="font-manrope text-xl md:text-2xl text-white hover:text-[#e1ff00] transition-colors"
            >
              {EMAIL}
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-20 text-neutral-600 font-outfit text-xs uppercase tracking-[0.2em]">
          <span className="font-bebas text-2xl tracking-[0.15em] text-neutral-500">
            Asraf Noor<span className="text-[#e1ff00]">.</span>
          </span>
          <span>© {new Date().getFullYear()}</span>
          <span>Made with too much coffee ☕</span>
        </div>
      </div>
    </footer>
  );
};
